import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";
import CargoCompanyDispatchMultiList from "./cargo-company-dispatch-multi-list";
import CargoCompanyDispatchMultiListParams from "./cargo-company-dispatch-multi-list-params";

const useCargoCompanyDispatchMultiList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<CargoCompanyDispatchMultiList>({ data: [], totalCount: 0 });

  const load = async (
    params: CargoCompanyDispatchMultiListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoCompanyDispatch =
        await cargoCompanyService.getDispatchMultiList(params, signal);

      setData(cargoCompanyDispatch);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useCargoCompanyDispatchMultiList;
